import React, { useState, useContext, useEffect } from 'react';
import { Grid, Box, Typography } from '@material-ui/core';
import AppsContext from './appContext';
import { DEEP_LINKS } from '@app/pages/ssoManager/addEditApplication.enums';
import { IDeepLink } from '@app/models';
import { ConfigureSync } from './appMsol';
import { DeepLink } from './appMsol/deepLink.component';
import { useDispatch } from 'react-redux';
import _ from 'lodash';
import { handleGetProvisioningPoliciesDTOData } from '@app/store/actions';
import { useTypedTranslation } from '@app/hooks';

interface IProps {
    state: any;
    setState: Function;
    isInvisible: boolean;
}

export const Synchronization: React.SFC<IProps> = ({ state, setState, isInvisible }: IProps) => {
    const { translation } = useTypedTranslation();
    const dispatch = useDispatch();

    const app = useContext(AppsContext);
    const [deepLinks, setDeepLinks] = useState<IDeepLink[]>([]);

    useEffect(() => {
        setDeepLinks(DEEP_LINKS);
        dispatch(handleGetProvisioningPoliciesDTOData());
    }, []);

    useEffect(() => {
        let domain = '';

        if (!state.managedSetup.domainGraphModule && !state.managedSetup.domain) {
            return;
        }

        domain = state.federationType === 'graph-module' ? state.managedSetup.domainGraphModule : state.managedSetup.domain;

        if (deepLinks.length !== 0 && domain !== '') {
            let config: any = {};

            if (app.ServiceConfiguration) {
                config = JSON.parse(app.ServiceConfiguration);
            }

            let deepLinksLocal: IDeepLink[];
            let newDeepLinks = [...deepLinks];

            deepLinksLocal = newDeepLinks.map((deepLink) => {
                // eslint-disable-next-line no-template-curly-in-string
                let url = deepLink.Url.replace('${domain}', domain);

                if (state.tenant !== '') {
                    // eslint-disable-next-line no-template-curly-in-string
                    url = url.replace('${managedomain}', state.tenant);
                }
                deepLink.Url = url;

                return deepLink;
            });

            setDeepLinks(deepLinksLocal);
            config['deep-links'] = JSON.stringify(deepLinksLocal);
            app.updateState('ServiceConfiguration', JSON.stringify(config));
        }
    }, [state.federationType, state.managedSetup.domainGraphModule, state.managedSetup.domain, state.tenant]);

    const updateBaseConfig = (name: string, value: unknown) => {
        if (
            ((name === 'importMsolUsersEnabled' && !state.importMsolGroupsEnabled) ||
                (name === 'importMsolGroupsEnabled' && !state.importMsolUsersEnabled)) &&
            !value
        ) {
            // both import values are false, set the top level import value to false as well
            let prevState = { ...state };
            prevState[name] = value as boolean;
            prevState.importMsolEnabled = false;
            setState(prevState);
        } else {
            // update first level properties
            setState((prevState: any) => ({ ...prevState, [name]: value }));
        }
    };

    const updateDeepLink = (index: number) => {
        let newDeepLink = _.cloneDeep(deepLinks);
        newDeepLink[index].Enabled = !newDeepLink[index].Enabled;
        setDeepLinks(newDeepLink);

        let config = JSON.parse(app.ServiceConfiguration);

        config['deep-links'] = JSON.stringify(newDeepLink);
        app.updateState('ServiceConfiguration', JSON.stringify(config));
    };

    return (
        <>
            <Grid container justifyContent='space-between' className={`configpanel-row ${isInvisible ? 'configpanel__invisible' : ''}`}>
                <Grid item xs={12} lg={7} className='configpanel-left'>
                    <Box p={4} mb={2}>
                        <ConfigureSync officeConfig={state} updateConfig={updateBaseConfig} appId={app.Id} />
                        <Typography variant='h6'>{translation('MSOL_DEEP_LINKS_HEADER')}</Typography>
                        <Typography variant='subtitle2'>{translation('MSOL_DEEP_LINKS_DESC')}</Typography>
                        <div className='deep-links'>
                            {deepLinks.map((deepLinkApp, index: number) => (
                                <DeepLink
                                    key={index}
                                    displayName={deepLinkApp.DisplayName}
                                    iconUrl={deepLinkApp.IconUrl}
                                    enabled={deepLinkApp.Enabled}
                                    onToggle={() => updateDeepLink(index)}
                                />
                            ))}
                        </div>
                    </Box>
                </Grid>
                <Grid item xs={12} lg={5} className='configpanel-right'>
                    <Box p={4}>
                        <div dangerouslySetInnerHTML={{ __html: translation('MSOL_HELP_TEXT_SYNC') }} />
                    </Box>
                </Grid>
            </Grid>
        </>
    );
};
